import { render, staticRenderFns } from "./ProductDescriptionAiModal.vue?vue&type=template&id=271c0d26&scoped=true&"
import script from "./ProductDescriptionAiModal.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptionAiModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDescriptionAiModal.vue?vue&type=style&index=0&id=271c0d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c0d26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VDivider,VProgressLinear,VRow,VSpacer,VTextarea})
